// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"405":"60970482","421":"d4c07c41","615":"3c828101","887":"5646b7d4"}[chunkId] + ".chunk.js";
};